import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Wrapper from '../../components/templates/SchoolWrapper';
import Title from '../../components/Service/SchoolClasses/Title';
import OneToOne from '../../components/Service/SchoolClasses/OneToOne';
import Pronunciation from '../../components/Service/SchoolClasses/Pronunciation';
import Level from '../../components/Service/SchoolClasses/Level';

const SchoolClassesMain = () => {
  const { t } = useTranslation('common');
  return (
    <Wrapper>
      <>
        <Head>
          <title>{t('title.school.effectiveClasses')}</title>
          <meta
            name="description"
            content={t('service.school.effectiveClasses.intro')}
          />
        </Head>
        <div className="school-main-content">
          <Title />
          <OneToOne />
          <Pronunciation />
          <Level />
        </div>
      </>
    </Wrapper>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default SchoolClassesMain;
